import { render, staticRenderFns } from "./AppointmentSuggestionItem.vue?vue&type=template&id=1b696b65&scoped=true&"
import script from "./AppointmentSuggestionItem.vue?vue&type=script&lang=ts&"
export * from "./AppointmentSuggestionItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentSuggestionItem.vue?vue&type=style&index=0&id=1b696b65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b696b65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow,VSpacer})
